/**
 * Shared types for admission consent form templates.
 */
import type { DocumentClinic } from '@/frontend/features/printing/documents/types'

/** Configuration for building an admission consent form. */
export interface AdmissionConsentConfig {
  id: string
  label: string
  /** Document title (e.g. "CONSENT FORM FOR SEDATION"). */
  title: string
  /** Clinic whose details appear in the header. Defaults to Snoots HQ. */
  clinic?: DocumentClinic
  /** Consent clauses rendered as checkboxes for the owner to tick when signing. */
  clauses: string[]
}

/** Fields for admission consent forms. */
export interface AdmissionConsentFields {
  weightToday: string
  allergies: string
  currentMedications: string
  procedure: string
  vetName: string
}

export const defaultAdmissionConsentFields: AdmissionConsentFields = {
  weightToday: '',
  allergies: '',
  currentMedications: '',
  procedure: '',
  vetName: '',
}
